// HelpPage.tsx
import React, { useEffect, useState } from "react";

type FAQ = {
  id: number;
  question: string;
  answer: string;
};

const HelpPage: React.FC = () => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);

  useEffect(() => {
    const fetchfaqs = async () => {
      setFaqs([
        {
          id: 1,
          question: "How do I create an account on Fan1?",
          answer:
            "To create an account, click on the 'Sign Up' button on the homepage and fill in the required details.",
        },
        {
          id: 2,
          question: "How can I reset my password?",
          answer:
            "Click on the 'Forgot Password' link on the login page and follow the instructions to reset your password.",
        },
        {
          id: 3,
          question: "What should I do if I encounter a technical issue?",
          answer:
            "If you encounter a technical issue, contact our support team via the 'Contact Support' form below or email us at support@fan1.com.",
        },
      ]);
    };
    fetchfaqs();
  },[]);

  const [expandedFaqId, setExpandedFaqId] = useState<number | null>(null);

  const toggleFaq = (id: number) => {
    setExpandedFaqId((prevId) => (prevId === id ? null : id));
  };

  return (
    <div className="container px-5">
      <div className="help-page">
        <h1>Help & Support</h1>

        <section className="faqs mb-5">
          <h2>Frequently Asked Questions</h2>
          {faqs.map((faq) => (
            <div key={faq.id} className="faq-item">
              <div onClick={() => toggleFaq(faq.id)} className="faq-button">
                <span>{faq.question}</span>
                <span>{expandedFaqId === faq.id ? "-" : "+"}</span>
              </div>
              {expandedFaqId === faq.id && (
                <p style={{ marginTop: "10px" }}>{faq.answer}</p>
              )}
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default HelpPage;
